import React from 'react';
import { 
  HelpCircle, 
  Brain, 
  BookOpen, 
  Server, 
  FileText, 
  TrendingUp, 
  Users,
  Database,
  Shield
} from 'lucide-react';

/**
 * Компонент боковой панели с полезными советами по внедрению ИИ
 */
const TipsSidebar = () => {
  const tips = [
    {
      icon: Brain,
      title: 'Выбор ИИ-решений',
      description: 'Выбирайте ИИ-системы, специально разработанные для образовательной среды, с учетом предметной области.'
    },
    {
      icon: Users,
      title: 'Обучение персонала',
      description: 'Вложение средств в качественное обучение преподавателей является ключевым фактором успешного внедрения.'
    },
    {
      icon: Database,
      title: 'Подготовка данных',
      description: 'Чистые, хорошо структурированные данные критически важны для эффективной работы ИИ-систем.'
    },
    {
      icon: TrendingUp,
      title: 'Оценка эффективности',
      description: 'Определите четкие метрики для измерения успеха внедрения ИИ в образовательные процессы.'
    },
    {
      icon: Shield,
      title: 'Безопасность данных',
      description: 'Обеспечьте защиту персональных данных студентов и соответствие требованиям регуляторов.'
    },
    {
      icon: FileText,
      title: 'Проектная документация',
      description: 'Детальная документация проекта поможет отслеживать прогресс и обеспечить преемственность.'
    },
    {
      icon: Server,
      title: 'Гибкая инфраструктура',
      description: 'Планируйте инфраструктуру с возможностью расширения по мере роста потребностей.'
    }
  ];

  return (
    <div className="bg-white dark:bg-gray-800 rounded-xl border border-gray-200 dark:border-gray-700 p-5 shadow-sm">
      <h3 className="text-lg font-medium text-gray-900 dark:text-white mb-4 flex items-center">
        <HelpCircle className="w-5 h-5 mr-2 text-indigo-500" />
        Советы по внедрению ИИ
      </h3>

      <div className="space-y-3">
        {tips.map((tip, index) => (
          <div 
            key={index} 
            className="flex items-start space-x-3 p-3 bg-gray-50 dark:bg-gray-700/30 rounded-lg border border-gray-200 dark:border-gray-700 hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors"
          >
            <tip.icon className="w-5 h-5 text-indigo-500 mt-1 flex-shrink-0" />
            <div>
              <h4 className="text-sm font-medium text-gray-900 dark:text-white mb-1">
                {tip.title}
              </h4>
              <p className="text-xs text-gray-600 dark:text-gray-400">
                {tip.description}
              </p>
            </div>
          </div>
        ))}
      </div>

      <div className="mt-6 p-4 bg-blue-50 dark:bg-blue-900/20 border border-blue-100 dark:border-blue-800 rounded-lg">
        <div className="flex items-start space-x-3">
          <BookOpen className="w-5 h-5 text-blue-500 mt-1 flex-shrink-0" />
          <div>
            <h4 className="text-sm font-semibold text-blue-700 dark:text-blue-300 mb-2">
              Бесплатная консультация
            </h4>
            <p className="text-xs text-blue-600 dark:text-blue-400 mb-3">
              Получите экспертную оценку потребностей вашего учебного заведения и индивидуальные рекомендации по внедрению ИИ.
            </p>
            <button className="w-full py-1.5 text-xs bg-blue-500 text-white rounded hover:bg-blue-600 transition-colors">
              Записаться на консультацию
            </button>
          </div>
        </div>
      </div>
      
      {/* Блок с ресурсами */}
      <div className="mt-6">
        <h4 className="text-sm font-medium text-gray-900 dark:text-white mb-2">
          Полезные ресурсы
        </h4>
        <ul className="text-xs text-indigo-600 dark:text-indigo-400 space-y-1.5">
          <li className="hover:underline cursor-pointer">
            → Руководство по интеграции ИИ в образование
          </li>
          <li className="hover:underline cursor-pointer">
            → Кейсы успешного внедрения ИИ в вузах
          </li>
          <li className="hover:underline cursor-pointer">
            → Инструменты для мониторинга эффективности
          </li>
          <li className="hover:underline cursor-pointer">
            → Правовые аспекты использования ИИ
          </li>
        </ul>
      </div>
    </div>
  );
};

export default TipsSidebar;